﻿import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from './authentication.service';

declare var alertify: any
alertify.set('notifier','position', 'top-right');


/**
 * Decides if a route can be activated.
 */
@Injectable() export class AuthGuard implements CanActivate {

    private roleName: string;
    private errorMessage: string = "";
    
    constructor(public authenticationService: AuthenticationService, private router: Router) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        
        if(state.url === "/administration") {
            if(this.authenticationService.userSubject.value.role != 'administrator') {
                this.errorMessage = "Uautoriseret";
                alertify.notify(this.errorMessage, 'error', 4, function(){});
                return false;
            }
            else {
                if (this.authenticationService.signinSubject.getValue()) {
                    // Signed in.
                    return true;
                }
            }
        }
        if(state.url === "/entry") {
            if(this.authenticationService.userSubject.value.role === null || this.authenticationService.userSubject.value.role === undefined) {
                this.errorMessage = "Uautoriseret";
                alertify.notify(this.errorMessage, 'error', 4, function(){});
                return false;
            }
            if(this.authenticationService.userSubject.value.role === 'overblik') {
                this.errorMessage = "Uautoriseret";
                alertify.notify(this.errorMessage, 'error', 4, function(){});
                return false;
            }
            else {
                if (this.authenticationService.signinSubject.getValue()) {
                    // Signed in.
                    return true;
                }
            }
        }
        if(state.url === "/dashboard") {
            if(this.authenticationService.userSubject.value.role === null || this.authenticationService.userSubject.value.role === undefined) {
                this.errorMessage = "Uautoriseret";
                alertify.notify(this.errorMessage, 'error', 4, function(){});
                return false;
            }
            if(this.authenticationService.userSubject.value.role === 'indtastning') {
                this.errorMessage = "Uautoriseret";
                alertify.notify(this.errorMessage, 'error', 4, function(){});
                return false;
            }
            else {
                if (this.authenticationService.signinSubject.getValue()) {
                    // Signed in.
                    return true;
                }
            }
        }    

        if (this.authenticationService.signinSubject.getValue()) {
            // Signed in.
            return true;
        }

        // Stores the attempted URL for redirecting.
        let url: string = "/entry";
        this.authenticationService.redirectUrl = url;
               

        // Not signed in so redirects to signin page.
        this.router.navigate(['/login']);

        return false;
    }

}
